module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qleg3-6638f4da395fb6b092bf78857b1cd3e2.jpg";